import { RequestService } from '../../../common/services/RequestService';
import { GET_STATUSES } from '../constants';

export const getRequestStatuses = payload => {
  return RequestService.get(GET_STATUSES);
};
